import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
            <i className="ri-star-line text-primary-500 mr-2"></i>
            为什么选择51今日大瓜
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuresData.map((feature) => (
              <div
                key={feature.id}
                className="bg-background-100 rounded-lg p-6 text-center"
              >
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className={`${feature.icon} text-xl text-primary-500`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-800 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}